import { AppModal } from './AppModal.js';

export const appModalContents = {
    about: {
        titleKey: 'mainMenu.about',
        icon: '/images/about-grey.svg',
        path: 'about',
        attachedLabel: true,
        documentSectionClass: 'about-modal-section',
        documents: [
            { url: '/{locale}/about.html', selector: 'main > section' },
            { url: '/{locale}/howto.html', selector: 'main > section' },
            { url: '/{locale}/cgu.html', selector: 'main > section' },
            { url: '/{locale}/legal.html', selector: 'main > section' },
            { url: '/{locale}/privacy.html', selector: 'main > section' }
        ]
    }
};

export class SimpleModal {
    constructor(app, contents = appModalContents) {
        this.app = app;
        this.contents = contents;
        this.modalStack = [];
        this.activeModal = null;
        this.renderer = new AppModal(this);
    }

    has(contentId) {
        return Boolean(this.contents[contentId]);
    }

    mount(contentId, options = {}) {
        const definition = this.contents[contentId];

        return definition
            ? this.renderer.mount(contentId, definition, options)
            : null;
    }

    open(contentId, returnFocus = null) {
        const definition = this.contents[contentId];

        return definition
            ? this.renderer.open(contentId, definition, returnFocus)
            : false;
    }

    whenRendered(contentId) {
        return this.renderer.modals.get(contentId)?.renderPromise || Promise.resolve();
    }

    showLoading() {
        return this.setLoading(this.activeModal, true);
    }

    hideLoading() {
        return this.setLoading(this.activeModal, false);
    }

    setLoading(activeModal, visible) {
        return this.renderer.setLoading(activeModal, visible);
    }

    close(activeModal = this.activeModal, onClosed = null) {
        return this.renderer.close(activeModal, onClosed);
    }
}
